import { MTDuplicationRuleTable } from './MTDuplicationRuleTable'

/**
 * MTDuplicationRulePage - Renders the Duplication Rule table for multi-territory.
 */
export function MTDuplicationRulePage() {
  return <MTDuplicationRuleTable />
}
